<template>
  <div class="ops-dashboard-base">
    <div class="ops-header">
      <h1 class="ops-title">{{ pageTitle }}</h1>
      <div class="ops-controls">
        <slot name="controls"></slot>
      </div>
    </div>

    <div class="ops-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "OpsBase",
  props: {
    pageTitle: {
      type: String,
      default: "Operations Dashboard",
    },
  },
  data() {
    return {
      // Common data that all ops pages might need
      loading: false,
      error: null,
      refreshInterval: null,
    };
  },
  computed: {
    currentUID() {
      return this.$store.getters.currentUID;
    },
    WID() {
      return this.$store.getters.WID;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
  methods: {
    // Common methods that all ops pages might need
    showError(message) {
      this.error = message;
      this.$alert.error(message);
    },
    showSuccess(message) {
      this.$alert.success(message);
    },
    setLoading(loading) {
      this.loading = loading;
    },
    // Method to refresh data - can be overridden in child components
    refreshData() {
      // Default implementation - child components can override
    },
    // Method to start auto-refresh
    startAutoRefresh(interval = 30000) {
      this.stopAutoRefresh();
      this.refreshInterval = setInterval(() => {
        this.refreshData();
      }, interval);
    },
    // Method to stop auto-refresh
    stopAutoRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },
  },
  beforeDestroy() {
    this.stopAutoRefresh();
  },
};
</script>

<style scoped>
.ops-dashboard-base {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.ops-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ops-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.ops-controls {
  display: flex;
  gap: 10px;
}

.ops-content {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
</style>
